document.addEventListener('DOMContentLoaded', function () {
  const navbar = document.querySelector('.neon-navbar');

  // 1. Initial Load & Hash Link Handler
  const hash = window.location.hash;
  if (hash && hash !== '#') {
    const targetEl = document.querySelector(hash);
    if (targetEl) {
      window.isNavNavigating = true;

      requestAnimationFrame(() => {
        setTimeout(() => {
          const targetTop = window.scrollY + targetEl.getBoundingClientRect().top;

          window.scrollTo({
            top: targetTop,
            behavior: 'instant',
          });

          // Reset Section 1 if targeted
          if (
            targetEl.matches('.scroll-trigger-wrapper, .scroll-trigger-one') &&
            typeof window.forceFirstPanel === 'function'
          ) {
            window.forceFirstPanel();
          }

          // Reset Section 2 if targeted
          if (
            targetEl.matches('.scroll-trigger-2-wrapper, .scroll-trigger-2') &&
            typeof window.forceFirstPanel2 === 'function'
          ) {
            window.forceFirstPanel2();
          }

          setTimeout(() => {
            window.isNavNavigating = false;
          }, 400);
        }, 100);
      });
    }
  }

  // 2. Navbar Scroll Visibility & Sticky / Logo Class Logic
  if (navbar) {
    const heroSection = document.querySelector('.neon-hero-section');

    if (heroSection) {
      const updateStickyState = () => {
        const rect = heroSection.getBoundingClientRect();
        const heroHeight = rect.height;

        // Triggers when 95% of the hero section is above the top of the viewport
        // (i.e. only 5% of hero remains in view at the top)
        const isNearHeroEnd = rect.bottom <= heroHeight * 0.05;

        if (isNearHeroEnd) {
          navbar.classList.add('sticky-active');
        } else {
          navbar.classList.remove('sticky-active');
        }
      };

      // Run immediately on page load / reload
      updateStickyState();

      // IntersectionObserver handles dynamic scroll entries
      // threshold: 0.05 triggers callbacks right around the 5% visibility mark
      const heroObserver = new IntersectionObserver(
        () => {
          updateStickyState();
        },
        { threshold: [0, 0.05, 0.1, 1.0] },
      );

      heroObserver.observe(heroSection);

      window.addEventListener('scroll', updateStickyState);
      window.addEventListener('resize', updateStickyState);
    }

    // 3. Navbar Buy Button Visibility Logic
    const imgSection1 = document.querySelector('.neon-img-section-1');

    if (imgSection1) {
      const updateBuyBtnVisibility = () => {
        const rect = imgSection1.getBoundingClientRect();
        // Adds class ONLY when top of section reaches or scrolls past the top of the viewport
        if (rect.top <= 0) {
          navbar.classList.add('show-buy-btn');
        } else {
          navbar.classList.remove('show-buy-btn');
        }
      };

      updateBuyBtnVisibility();

      const buyBtnObserver = new IntersectionObserver(
        () => {
          updateBuyBtnVisibility();
        },
        { threshold: [0, 0.01] },
      );

      buyBtnObserver.observe(imgSection1);
      window.addEventListener('scroll', updateBuyBtnVisibility);
      window.addEventListener('resize', updateBuyBtnVisibility);
    }
  }

  // 4. Smooth Anchor Click Handler
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;

      const targetEl = document.querySelector(targetId);
      if (!targetEl) return;

      e.preventDefault();

      window.isNavNavigating = true;

      document.body.classList.remove('st-locked');
      document.body.style.overflow = '';

      // Check for Section 1 targets
      const isTargetingSec1 =
        targetEl.matches('.scroll-trigger-wrapper, .scroll-trigger-one') || targetEl.closest('.scroll-trigger-wrapper');
      if (isTargetingSec1 && typeof window.forceFirstPanel === 'function') {
        window.forceFirstPanel();
      }

      // Check for Section 2 targets
      const isTargetingSec2 =
        targetEl.matches('.scroll-trigger-2-wrapper, .scroll-trigger-2') ||
        targetEl.closest('.scroll-trigger-2-wrapper');
      if (isTargetingSec2 && typeof window.forceFirstPanel2 === 'function') {
        window.forceFirstPanel2();
      }

      const targetTop = window.scrollY + targetEl.getBoundingClientRect().top;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });

      // Release navigation lock smoothly without triggering premature scroll events
      setTimeout(() => {
        window.isNavNavigating = false;
      }, 1000);
    });
  });
});
